export default{
  affiliates: (state) => state.affiliates,
  affiliate: (state) => state.affiliate
}



// WEBPACK FOOTER //
// ./src/components/affiliate/store/getters.js